(function (angular) {
    'use strict';
    angular.module("dentist").controller('profileController', profileController);

    function profileController(dentistService, $filter, $translate, $stateParams, $rootScope) {
    	
        //jQuery functions initialization
        jQuery(function() {
//            initSlickCarousel();
            initSameHeight();
            initItemsZindex();
//            initLightbox();
//            initCustomMap();
            initLoadMore();
//            initLightboxOpener();
            initFixedBlock();
            initNavigationSelect();
            initCustomForms();
            initFixedMap();
            initializeSmoothScrolling();

            initializeSafariLinkFix();
        });
        
        //TODO[Igor]: to be augmentented appropriatelly, to be dynamic when doing i18n task
        $translate.use('de');

        //controller initialization
        var ctrl = this;

        $('#profileModal').on('show.bs.modal', function (event) {
        	  var button = $(event.relatedTarget) // Button that triggered the modal
        	  var modal = $(this)
        	  modal.find('.modal-title').text('Lebenslauf')
        	  modal.find('.modal-body').load(button.attr('attribute'));
    	});
        
        ctrl.Checkwindow = Checkwindow;
        ctrl.isMobile = false;
        function Checkwindow() {
        	if (window.screen.width < 768) {
                ctrl.isMobile = true;
            }
            else {
                ctrl.isMobile = false;
            }
        }
        ctrl.Checkwindow();
        //bindable objects
        ctrl.data = { practiceId: $stateParams.practice.id };
        ctrl.Practitioners = [];
        ctrl.profileData = {
        		practiceSalutation: "",
        		practiceNameOne: "",
        		practiceName: "",
        		taxpunktwert: "",
        		practiceWelcomeNote: "",
        		practiceSlogan: "",
        		staff: [],
        		galleryDescription: "",
        		gallery: [],
        		mapCoordX: '',
        		mapCoordY: '',
        		addressStreet: "",
        		addressCity: "",
        		postalCode: "",
        		locationDirections: "",
        		languages: "",
        		specializations: "",
        		treatmentExperiences: [],
        		practiceProfilePath: "",
        		teaser: false,
        		teaserData: "",
        		averageRating: 0,
        		ratingText: "",
        		practiceReview: angular.toJson({})
        		//testimonialJsonMap: {}
        }
        ctrl.cityRegion = window.cityRegion;
        //bindable properties
        ctrl.isExpanded = (!!$stateParams.expanded || $stateParams.expanded === '');
        ctrl.staticUrl = "https://static.zumedo.ch/resources/" + ctrl.data.practiceId + "/"; //========= url for images
        ctrl.platformBookingLink = "/platformBooking/#/?practiceId=".concat(ctrl.data.practiceId);
        ctrl.treatmentExperiencesCounter = 2;
        ctrl.treatmentExperiencesCounterStep = 6;

        ctrl.ecommerceObject = JSON.parse(localStorage.getItem("ecommerceObject"));
        if(ctrl.ecommerceObject == null || typeof ctrl.ecommerceObject === "undefined") {
        	var gtmDataLayer = window.dataLayer || [];

        	var data = {
        		'ecommerce': {
	          	    'currencyCode': 'CHF',
	          	    'click': {
	          	        'products': [{
	          	          'name': 'DirectProfileClick',                      // Name or ID is required.
	          	          'brand': $stateParams.practice.name
	          	         }]
	          	       }
	          	  }
            };

        	gtmDataLayer.push(data);

        	gtmDataLayer.push({
                'event':'businesscardClick'
            });
        }
        
        init();

        function init() {
        	getPracticeProfile($stateParams.practice);
            

            if(isBot()){
            	ctrl.treatmentExperiencesCounter = ctrl.profileData.treatmentExperiences.length;
            }
        }
        
        function calculateAverage() {
			var numberOfExperiences = ctrl.profileData.treatmentExperiences.length, reviews = [];
            for(var i=0; i<ctrl.profileData.treatmentExperiences.length; i++) {
            	if(ctrl.profileData.treatmentExperiences[i].averageRating == 0) {
            		numberOfExperiences --;
            	} else {
                    ctrl.profileData.treatmentExperiences[i].averageRating = $filter('number')(ctrl.profileData.treatmentExperiences[i].averageRating, 1).replace('.0','');

            		reviews.push({
    		            	  "@type": "Review",
    		            	  "datePublished": ctrl.profileData.treatmentExperiences[i].date,
    		            	  "reviewBody": "Positiv: " + ctrl.profileData.treatmentExperiences[i].good + (ctrl.profileData.treatmentExperiences[i].improvementPotential && ctrl.profileData.treatmentExperiences[i].improvementPotential != "" ? " | Potenzial: " + ctrl.profileData.treatmentExperiences[i].improvementPotential : ""),
    		            	  "reviewRating": {
    		            	    "@type": "Rating",
    		            	    "ratingValue": ctrl.profileData.treatmentExperiences[i].averageRating / 2
    		            	  },
    		            	  "author": {
    		            		  "@type": "Person",
    		            		  "name": ctrl.profileData.treatmentExperiences[i].firstname
    		            	  }
            			});
            		}
        	    }

//            	ctrl.profileData.testimonialJsonMap[ctrl.profileData.treatmentExperiences[i].id] = angular.toJson(review.schemaObject);
            	ctrl.profileData.ratingText = (ctrl.profileData.averageRating >= 0 && ctrl.profileData.averageRating < 7) ? 'Besuchererlebnis'
								: (ctrl.profileData.averageRating >= 7 && ctrl.profileData.averageRating < 8 ? 'Gut'
									: (ctrl.profileData.averageRating >= 8 && ctrl.profileData.averageRating < 8.5 ? 'Sehr Gut'
										: (ctrl.profileData.averageRating >= 8.5 && ctrl.profileData.averageRating < 9 ? 'Fabelhaft'
											: (ctrl.profileData.averageRating >= 9 && ctrl.profileData.averageRating < 9.5 ? 'Hervorragend'
												: (ctrl.profileData.averageRating >= 9.5 && ctrl.profileData.averageRating <= 10 ? 'Aussergewöhnlich'
													: '')))));

				//Aggregate Rating of Practice
				if(ctrl.profileData.averageRating > 0) {
                    ctrl.profileData.averageRating = $filter('number')(ctrl.profileData.averageRating, 1).replace('.0','');

                    // TODO test with "zahnarzt pourmand zürich" and "zahnarzt baumgartner zürich kreis 4". Also test new breadcrumbs with 'Zahnarzt'.
                    var dentistName = null;
                    if (ctrl.profileData.staff && ctrl.profileData.staff[0]) {
                        var employee = ctrl.profileData.staff[0];
                        var dentistName = (employee.titleText ? employee.titleText + ' ' : (employee.title ? $filter('translate')(employee.title) + ' ' : '')) + employee.firstname + ' ' + employee.lastname;
                    }

					var practiceReview = {
		    			schemaObject: {
	    				  "@context": "https://schema.org/",
		            	  "@type": "LocalBusiness",
		            	  "@id": "https://www.zumedo.ch/zahnarzt/" + ctrl.profileData.location + "/" + ctrl.profileData.practiceProfilePath,
		            	  "image": ctrl.profileData.gallery,
		            	  "name": ctrl.profileData.practiceName + (dentistName ? ', ' + dentistName : ''),
		            	  "geo": {
		            		  "@type": "GeoCoordinates",
		            		  "latitude": ctrl.profileData.mapCoordX,
		            		  "longitude": ctrl.profileData.mapCoordY
		            	  },
		            	  "aggregateRating": {
		            		  "@type": "AggregateRating",
		            		  "ratingValue": ctrl.profileData.averageRating / 2,
		            		  "reviewCount": ctrl.profileData.treatmentExperiences.length,
		            		  "ratingCount": numberOfExperiences,
		            		  "author": {
		            			  "@type": "Organization",
		            			  "name": "Zumedo"
		            		  }
		            	  },
		            	  "address" :{
		            		  "@type": "PostalAddress",
		            		  "streetAddress": ctrl.profileData.addressStreet,
		            		  "addressLocality": ctrl.profileData.addressCity,
		            		  "addressRegion": ctrl.cityRegion[ctrl.profileData.location],
		            		  "postalCode": ctrl.profileData.postalCode,
		            		  "addressCountry": "Schweiz"
		            	  },
		            	  "reviews": reviews
		    			}
					}
					ctrl.profileData.practiceReview = angular.toJson(practiceReview.schemaObject);
				}
        }

        function getPracticeProfile(result) {
            if(result.practitioners) {
            	ctrl.profileData.staff = result.practitioners;
            }
            
            if(result.practiceProfile) {
            	ctrl.profileData.gallery = result.practiceProfile.images.split(' ').join('').split(",");
                ctrl.profileData.gallery.forEach(function(imgName, index) {
                	ctrl.profileData.gallery[index] = ctrl.staticUrl + imgName;
                });
                ctrl.profileData.galleryDescription = result.practiceProfile.description.replace(/\n\s*\n\s*\n/g, '\n\n').replace(/\n\s*/g, '\n\n');
                ctrl.profileData.locationDirections = result.practiceProfile.location_directions;
                ctrl.profileData.practiceWelcomeNote = result.practiceProfile.welcome_message;
                ctrl.profileData.practiceSlogan = result.practiceProfile.slogan;
                ctrl.profileData.locationDirections = result.practiceProfile.location_directions;

                if(result.practiceProfile.taxpunktwert != null && result.practiceProfile.taxpunktwert != '') {
                	ctrl.profileData.taxpunktwert = result.practiceProfile.taxpunktwert;
                }
            }
            
            if(ctrl.profileData.taxpunktwert == '' && result.taxpunktwert != null && result.taxpunktwert != '' ) {
            	ctrl.profileData.taxpunktwert = "Taxpunktwert " + result.taxpunktwert;
            }
            
            var totalWords = result.name;
            var firstWord = totalWords.replace(/ .*/,'');

            ctrl.profileData.location = result.location;
            ctrl.profileData.locationDescription = result.locationDescription;
            ctrl.profileData.practiceSalutation = firstWord;
            ctrl.profileData.practiceNameOne = result.name.replace(firstWord,'');
            ctrl.profileData.practiceName = result.name;
            
            ctrl.profileData.languages = result.languages ? result.languages : '';
            ctrl.profileData.specializations = result.specializations ? result.specializations : '';
            ctrl.profileData.mapCoordX = result.coordinates.split(',')[0];
            ctrl.profileData.mapCoordY = result.coordinates.split(',')[1];
            ctrl.profileData.addressStreet = result.addressStreet + " " + ((result.addressStreetNumber != null && result.addressStreetNumber != "") ? result.addressStreetNumber : "");
            ctrl.profileData.addressStreetMore = result.addressStreetMore;
            ctrl.profileData.addressCity = result.addressCity;
            ctrl.profileData.postalCode = result.addressPostalCode;

            //TODO check profile path when everything is implemented
            ctrl.profileData.practiceProfilePath = result.profilePath;

            ctrl.profileData.treatmentExperiences = result.treatmentExperiences;
            ctrl.profileData.averageRating = result.averageRating;

            if(window.teaserTreatmentExperiences[result.id] != 'undefined' && window.teaserTreatmentExperiences[result.id] != null) {
            	var array = window.teaserTreatmentExperiences[result.id];
            	for(var i=0; i<array.length; i++) {
            		ctrl.profileData.treatmentExperiences.push(array[i]);
            	}
            }

            /*** Teaser profile support begin ***/
            ctrl.profileData.teaser = result.teaser;
            ctrl.profileData.teaserData = result.teaserData;
            if(ctrl.profileData.teaser) {
            	$('.teaserHide').hide();
                $('.teaserShow').show();
            } else {
            	$('.teaserHide').show();
            	$('.teaserShow').hide();
            	
            }
            
            // TODO check teaser data string more thouroughly once pattern agreed upon. e.g. /^(MR|MS);[-\w.äüöÄÖÜèéà ]*;[-\w.äüöÄÖÜèéà ]+(;[-.:/\wäüöÄÖÜèéà ]*)*$/
            if(ctrl.profileData.teaserData != null && ctrl.profileData.teaserData) {
            	ctrl.profileData.teaserData = ctrl.profileData.teaserData.split(';');
            	if(ctrl.profileData.teaserData.length > 4) {
            		console.log("TEASER DATA PARSING ERROR - wrong length - more than 4 attributes");
            	} else if(ctrl.profileData.teaserData.length < 3) {
            		console.log("TEASER DATA PARSING ERROR - wrong length - less than 3 attributes");
            	}
            	
            	if(ctrl.profileData.teaserData[0] != 'MR' && ctrl.profileData.teaserData[0] != 'MS') {
            		console.log("TEASER DATA PARSING ERROR - gender wrong in first field of teaser data");
            	}
            
                if(ctrl.profileData.locationDirections == null) {
                	ctrl.profileData.locationDirections = "";
                }
            }
            
            calculateAverage();

            var marker = buildMapDataMarkers();
            $("#customMapProfile").data("markers", marker);
            initCustomMap();
            
            /********** Google breadcrumbs, object for both background & render *********/
            ctrl.breadcrumb = {
            		schemaObject: {
            		  "@context": "http://schema.org",
        			  "@type": "BreadcrumbList",
        			  "itemListElement": [{
        			    "@type": "ListItem",
        			    "position": 1,
      			        "item": "https://www.zumedo.ch/zahnarzt/",
    			        "name": "Zahnarzt"
        			  },{
        			    "@type": "ListItem",
          			    "position": 2,
        			    "item": "https://www.zumedo.ch/zahnarzt/" + ctrl.profileData.location + "/",
          			    "name": $filter('translate')(ctrl.profileData.location)
              		  },{
        			    "@type": "ListItem",
        			    "position": 3,
      			      	"item": "https://www.zumedo.ch/zahnarzt/" + ctrl.profileData.location + "/" + ctrl.profileData.practiceProfilePath,
      			      	"name": ctrl.profileData.practiceName
        			  }]
            		} 
                };
            
            ctrl.breadcrumb.jsonString = angular.toJson(ctrl.breadcrumb.schemaObject);
            var breadcrumbListItemOnlyRender = { // currently, we want this item only on the rendered profile page, and not on the search results
                 /* "@type": "ListItem",
                    "position": 3, */
                    "item": "https://www.zumedo.ch/zahnarzt/" + ctrl.profileData.location + "/suche",
                    "name": "Suche"
                  };
            ctrl.breadcrumb.schemaObject.itemListElement[0].item = "https://www.zumedo.ch/"; // on profile, Zahnarzt should point to landing-page
            ctrl.breadcrumb.schemaObject.itemListElement.splice(2, 0, breadcrumbListItemOnlyRender);
        }
        
        function buildMapDataMarkers() {
        	var mapDataMarkers = [];
        	var currentMarker = { "location": [] };
        	
        	currentMarker.location.push(Number(ctrl.profileData.mapCoordX));
        	currentMarker.location.push(Number(ctrl.profileData.mapCoordY));
        	currentMarker.extraClass = "custom-marker-active";
        	currentMarker.popupHTML = "<span class='map-marker')><span class='icon-marker'></span></span>";
        	
        	mapDataMarkers.push(currentMarker);
        	
        	return mapDataMarkers;
        }
        
    }
    
    function isBot(){
    	var botPattern = "(googlebot\/|Google Page Speed Insights|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var re = new RegExp(botPattern, 'i');
        return re.test(navigator.userAgent);
    }

    profileController.$inject = ['dentistService', '$filter', '$translate', '$stateParams', '$rootScope'];

})(window.angular);
